import { createBrowserRouter } from 'react-router';
import { AppShell } from './AppShell';
import { NotFound, RouteError, RouteLoading } from './routes/ErrorPages';
import { HomePage } from './routes/HomePage';

/**
 * Route contract (docs/03): `/`, `/library`, `/studio/:projectId`, `/projects`,
 * `/print/:projectId`, `/settings`. Static hosts must fall back to index.html.
 * Everything except the start page loads on demand (docs/11 initial-JavaScript budget).
 */
export const router = createBrowserRouter([
  {
    element: <AppShell />,
    errorElement: <RouteError />,
    hydrateFallbackElement: <RouteLoading />,
    children: [
      { path: '/', element: <HomePage /> },
      {
        path: '/library',
        lazy: async () => ({ Component: (await import('./routes/LibraryPage')).LibraryPage }),
      },
      {
        path: '/projects',
        lazy: async () => ({ Component: (await import('./routes/ProjectsPage')).ProjectsPage }),
      },
      {
        path: '/settings',
        lazy: async () => ({ Component: (await import('@/features/settings')).SettingsPage }),
      },
      { path: '*', element: <NotFound /> },
    ],
  },
  {
    path: '/studio/:projectId',
    lazy: async () => ({ Component: (await import('./routes/StudioPage')).StudioRoute }),
    errorElement: <RouteError />,
    hydrateFallbackElement: <RouteLoading />,
  },
  {
    path: '/print/:projectId',
    lazy: async () => ({ Component: (await import('./routes/PrintPage')).PrintRoute }),
    errorElement: <RouteError />,
    hydrateFallbackElement: <RouteLoading />,
  },
]);
